import cookie from 'cookie'
import loglevel from 'loglevel'

const options = JSON.parse('{"debug":false,"disable":false,"logLevel":"silent","namespace":"ati","npoSiteId":595271,"siteId":59,"project":"metterdaad","isPlusSite":false}')
const { npoSiteId, siteId, logLevel, namespace, isPlusSite } = options
const log = loglevel.getLogger('ati-plugin-client')
log.setLevel(logLevel)

/**
 * Create the plugin
 *
 * export default function (ctx, inject) {
 * https://nuxtjs.org/docs/2.x/directory-structure/plugins#inject-in-root--context
 *
 * get router info and store from context
 */
export default ({ app: { router }, store }) => {
  /**
   * Router setup
   */
  let isRouterReady = false

  router.onReady(() => {
    log.debug(`[${namespace}] router.onReady called`)
    // Mark when the router has completed the initial navigation.
    isRouterReady = true
  })

  /**
   * CCM setup
   */
  let unwatch = () => {}

  /**
   * Get uri for page counter name (former ati_name)
   *
   * Page counter is a transformed url path
   * -1 get path
   * -2 to lowercase
   * -3 hash # replace with /
   * -4 replace non-alpha-numeric characters with _
   * -5 remove trailing / for subpages
   */
  const getUri = (to) => {
    // 1 fullpath includes hash || path + hash
    let uri = to ? to.fullPath : (location.pathname + location.hash)
    log.debug(`[${namespace}] trackingName from '${(to ? 'to':'location')}':`, uri, { to, location })

    // 2 to lowercase
    uri = uri.toLowerCase()
    log.debug(`[${namespace}] uri lowercase:`, uri)

    // 3 replace hash with /
    uri = uri.replace(/#/g, '/hashtag-')
    log.debug(`[${namespace}] uri unhashed:`, uri)

    // 4 Remove all non-alpha-numeric characters
    uri = uri.replace(/[^a-zA-Z0-9.\-_/]/g, '_')
    log.debug(`[${namespace}] uri alpha-numeric:`, uri)

    if (uri !== '/') {
      // 5 For subpages remove the last slash if this url ends with a slash
      uri = uri.replace(/\/$/, '')
      log.debug(`[${namespace}] uri without slash on end:`, uri)
    }

    return uri
  }

  /**
   * Get the "plus site" -art for page counter chapter1 (former ati_chapter1)
   *
   * Determine project
   * It depends on what the data department needs.
   *
   * PROGRAMS
   * All subpages of /programmas, chapter1 is the program name
   * URL /programmas/programmanaam (or a subpage) then
   * chapter1 ==> 'programmanaam'.
   */
  const getProject = (to) => {
    const path = to ? to.path : location.pathname
    const elements = path.toLowerCase().split('/')
    let { project } = options
    log.debug(`[${namespace}] create projectname with`, { path, elements, project })

    /**
     * PROGRAMS
     * On program pages, override chapter1
     * https://www.eo.nl/programmas/het-familiediner => het-familiediner
     */
    if (elements.length > 2 && (elements[1] === 'programmas' || elements[1] === 'podcasts')) {
      project = elements[2]
    }
    /**
     * https://over.eo.nl/pers/programmas/het-familiediner => het-familiediner
     */
    else if (elements.length > 3 && (elements[2] === 'programmas' || elements[2] === 'podcasts')) {
      project = elements[3]
    }

    /**
     * Sanitize
     * For backwardcompatablity remove dashes. het-familiediner -> hetfamiliediner
     */
    if (project) {
      project = project.split('-').join('')
    }

    return project
  }

  /**
   * Get type of current page
   * Available values:
   * - home
   * - index
   * - article
   *
   * @param {Object} to
   * @returns
   */
  const getPageType = (to) => {
    const path = to ? to.path : location.pathname
    const elements = path.toLowerCase().split('/')
    // is homepage
    if (!elements || elements.length < 3 && elements.slice(-1).pop() === '') {
      return 'home'
    }
    // exception for 'pers/programmas/programma-name' uri
    if (elements.length === 4 && (elements[2] === 'programmas' || elements[2] === 'podcasts')) {
      return 'home'
    }
    if (elements.length === 3) {
      switch (elements[1]) {
        case 'programmas':
        case 'podcasts':
          return 'home'
        case 'artikel':
        case 'blog':
        case 'blogs':
          return 'article'
      }
    }
    return 'index'
  }

  /**
   * The actual tracking
   */
  const atTracking = (to) => {
    log.debug(`[${namespace}] Track`, { to })

    if (!store.state.cookieConsent.analytics) {
      log.warn(`[${namespace}] Disabled due to no consent`)
      return
    }

    // Always create new Tag, otherwise old data will persist
    window.tag = new window.ATInternet.Tracker.Tag()

    const uri = getUri(to)
    const project = getProject(to)
    const pageType = getPageType(to)

    window.tag.page.set({
      /**
       * Dimensie of metric
       * - Pagename
       *
       * Regels mbt de waarde
       * - Zelf vrij in te vullen. Start altijd met de level2-naam. Suggestie is daarna de chapters en nog een uniek label waar nodig toe te voegen
       *
       * Regels mbt de context
       * -
       */
      name: uri,
      /**
       * Dimensie of metric
       * - Level 1 (Pages)
       *
       * Regels mbt de waarde
       * - Voor productie  altijd dezelfde waarde, namelijk: “595271”
       *
       * Regels mbt de context
       * - Voor tests, gebruik “596579”
       */
      level1: npoSiteId,
      /**
       * Dimensie of metric
       * -Level 2 (Pages)
       *
       * Regels mbt de waarde
       * - Elk  portal of toegekende standalone site heeft een unieke numerieke waarde. Gebruik de lijst van waarden in het taggingplan om deze waarden te bepalen.
       *
       * Regels mbt de context
       * - Als er een nieuwe standalone site wordt toegekend zal een nieuwe waarde worden teogevoegd aan de lijst in het tagging plan.
       */
      level2: siteId,
      /**
       * Dimensie of metric
       * - ?
       *
       * Regels mbt de waarde
       * - ?
       *
       * Regels mbt de context
       * - ?
       */
      chapter1: project,
    })
    window.tag.customVars.set({
      site: {
        /**
         * Dimensie of metric
         * - Platform (custom site variable)
         *
         * Regels mbt de waarde
         * - De naam en het format van het ID van deze variabele niet aanpassen of verwijderen. Verwachte waarden: “site”, “app” of “tv”
         *
         * Regels mbt de context
         * - Waarde moet gepusht worden op elk scherm of elke page load
         */
        1: '[site]',
        /**
         * Dimensie of metric
         * - Broadcaster (custom site variable)
         *
         * Regels mbt de waarde
         * - Omroep behorende bij de bezochte site of app. Alleen aanwezig indien relevant (als de pagina/site over een specifieke programma of omroep gaat. Leeg als niet).
         *
         * Regels mbt de context
         * - Kan meerdere omroepen bevatten als het om een coproductie gaat. Samenvoegen met _|_ als scheidingsteken.
         */
        2: '[eo]',
        /**
         * Dimensie of metric
         * - Programma (custom site variable)
         *
         * Regels mbt de waarde
         * - Welk programma hoort bij deze pagina? Alleen aanwezig indien relevant (als de pagina/site over een specifiek programma of omroep gaat. Leeg als niet)
         *
         * Regels mbt de context
         * - Bij een programma-app of -pagina altijd vullen. Bij een portal vullen als de pagina specifiek een bepaald programma betreft
         */
        3: project ? `[${project}]` : '',
        /**
         * Dimensie of metric
         * - MerkType
         *
         * Regels mbt de waarde
         * - “portal” of “standalone” waar ‘standalone’ wordt gebruikt voor zogenoemde plussites.
         *
         * Regels mbt de context
         * - Waarde moet gepusht worden op elk scherm of elke page load
         */
        4: isPlusSite ? '[standalone]' : '[portal]',
        /**
         * Dimensie of metric
         * - Geëncrypteerde IDFA (custom site variable)
         *
         * Regels mbt de waarde
         * - De naam en het format van het ID van deze variabele niet aanpassen of verwijderen. De waarde is de IDFA of the user, hashed under MD5, en dan truncated van 32 naar 16 karakters.
         *
         * Regels mbt de context
         * - Waarde moet gepusht worden op elk scherm of elke page load. Deze waarde alleen voor apps vullen.
         */
        // 5: null,
        /**
         * Dimensie of metric
         * - Event type (custom site variable)
         *
         * Regels mbt de waarde
         * - De verwachte waarden zijn “home”, “index” of “article”
         *
         * Regels mbt de context
         * - Push “home” voor de homepage van een app of site.
         * - Push “index” voor een indexpagina, Dit is een pagina met links naar meerdere artikelen..
         * - Push “article” voor een pagina met content. Bijvoorbeeld een artikel, videocontent or audiocontent”
         */
        6: pageType ? `[${pageType}]` : '[home]',
        /**
         * Dimensie of metric
         * - Media type (custom site variable)
         *
         * Regels mbt de waarde
         * - De naam en het format van het ID van deze variabele niet aanpassen of verwijderen.. De verwachte waarden zijn “general”, “replica”, “non-replica”, “videostream”, “radiostream” of “e-mail”
         *
         * Regels mbt de context
         * - “general”: standaardwaarde, reguliere pagina.
         * - “replica” : online kopie van een kranten- of magazine-artikel (erg zeldzaam voor NPO)
         * - “videostream”: Een pagina bestaand uit videocontent of streams. Gebruik voor een nieuwsartikel met een link naar een video de waarde  “general”.
         * - “radiostream”: Een pagina bestaand uit radiocontent of streams. Gebruik voor een nieuwsartikel met een link naar een radiofragment de waarde  “general”..
         */
        7: '[general]',
        /**
         * Dimensie of metric
         * - Omroeplabel 1 t/m 5 (8 t/m 12)
         *
         * Regels mbt de waarde
         * - Deze labels kan elke omroep voor eigen behoeftes gebruiken.
         */
        8: '',
        9: '',
        10: '',
        11: '',
        12: '',
      },
    })
    window.tag.dispatch()
    log.debug(`[${namespace}] Tag dispatched`)
  }

  /**
   * Initialize tracking
   */
  function init () {
    log.info(`[${namespace}] Initialize tracking`)
    const scriptId = `${namespace}-script`
    /**
     * Turn off Nuxt watcher for Vuex store changes
     */
    unwatch()

    /**
     * Inject asynchronious AT internet script in the DOM
     * https://developers.atinternet-solutions.com/javascript-en/advanced-features-javascript-en/asynchronous-tag-javascript-en/
     */
    if (!document.getElementById(scriptId)) {
      log.info(`[${namespace}] Create window.ATInternet and inject script`)
      window.ATInternet = window.ATInternet || {};
      window.ATInternet.onTrackerLoad = () => {
        window.tag = new window.ATInternet.Tracker.Tag();
      };

      // Add script tag
      const script = document.createElement('script')
      script.id = scriptId
      script.type = 'text/javascript'
      script.async = 'async'
      script.src = `https://tag.aticdn.net/${npoSiteId}/smarttag.js`
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
    }
    log.debug(`[${namespace}] window.ATInternet exists`)

    if (window.ATInternet.Tracker) {
      log.debug(`[${namespace}] window.ATInternet.Tracker exists`)
      startTracking()
    } else {
      log.debug(`[${namespace}] window.ATInternet.Tracker not loaded yet`)
      window.ATInternet.onTrackerLoad = startTracking
    }
  }

  const saveUserIdToStore = () => {
    /**
     * Get cookies
     */
    if (!document || !document.cookie) {
      return
    }
    const cookies = cookie.parse(document.cookie)

    /**
     * Get cookie from AT Internet
     */
    if (!cookies.atuserid) {
      return
    }

    store.dispatch('atInternet/saveCookieInStore', cookies.atuserid)
  }

  /**
   * Start the tracking
   * The Nuxt way is to use router.afterEach
   * NOTE router.afterEach is called *before* DOM is updated.
   * So for serverside rendering, the first page must use window location
   */
  function startTracking () {
    log.info(`[${namespace}] Start tracking`)
    /**
     * Track server rendered page
     */
    if (isRouterReady) {
      atTracking()
    }

    /**
     * Save site and user information in store
     */
    store.dispatch('atInternet/setSiteId', siteId)
    saveUserIdToStore()

    /**
     * Track all client rendered pages
     */
    router.afterEach(atTracking)
  }

  // Wait 2.5 seconds before initializing, so the application itself can be rendered first
  setTimeout(function () {
    /**
     * Check if permissions are set for analytics
     */
    if (store.state.cookieConsent.analytics) {
      init()
      log.info(`[${namespace}] Has consent`)
    } else {
      /**
       * If CCM wasn't fired before then set a watcher for when it does.
       * Set the unwatch function
       */
      unwatch = store.watch(
        state => state.cookieConsent.analytics,
        (analytics) => {
          log.info(`[${namespace}] Store permissions changed`, analytics)

          if (analytics) {
            init()
          }
        },
        { immediate: true },
      )
      log.info(`[${namespace}] Start watching for consent`, store.state.cookieConsent)
    }
  }, 2500)
}
